import { PAdbContext } from "../PA.Core/PAdbContext";
import * as AsyncLock from "async-lock";

import * as _ from "lodash";
import {
    WB_PolicyRow,
    WB_PolicyCubeTermRow,
    WB_PricingEnginePriceRelRow,
    WB_ProductConditionTypeRow,
    WB_PolicyTermTypeRow
} from "../PA.Core/PAdbSchemaRows";
import {
    esWB_Policy,
    esWB_Policy_Cube,
    esWB_Policy_Cube_TermR,
    esWB_Policy_Term,
    esWB_Policy_Term_Type
} from "../PA.Core/PAdbSchema";

import { DateUtils } from "../PA.Core/Basic/Dates";
/**
 * @deprecated This class should not be used
 */
export class PolicyService {
    private static _dbContext: PAdbContext;

    private static dctCndTypeWbIDByPolicyWbIDCndTypeID: {
        [policyWbID: number]: { [reservedTerm: string]: { [key: string]: number } };
    } = {};
    private static dctPolicyByWbID: { [wbID: number]: WB_PolicyRow[] } = {};
    private static dctPolicyOutputTermByWbID: { [wbID: number]: WB_PolicyCubeTermRow } = {};

    private static bIsLoaded: boolean = false;

    static getConditionTypeWbIDByPolicyReservedTermID(
        policies: number[],
        reservedTerm: string,
        wbPrdTypeId: number,
        wbCustTypeId: number
    ): Promise<number> {
        return new Promise<number>((resolve, error) => {
            PolicyService.loadFromDB()
                .then((ignore) => {
                    const key = wbPrdTypeId + "-" + wbCustTypeId;

                    for (const wbPolicyId of policies) {
                        if (
                            wbPolicyId in PolicyService.dctCndTypeWbIDByPolicyWbIDCndTypeID &&
                            reservedTerm in PolicyService.dctCndTypeWbIDByPolicyWbIDCndTypeID[wbPolicyId] &&
                            key in PolicyService.dctCndTypeWbIDByPolicyWbIDCndTypeID[wbPolicyId][reservedTerm]
                        ) {
                            resolve(PolicyService.dctCndTypeWbIDByPolicyWbIDCndTypeID[wbPolicyId][reservedTerm][key]);
                            return;
                        }
                    }
                    if (PolicyService.bIsLoaded) {
                        resolve(undefined);
                        return;
                    }
                })
                .catch((err) => {
                    error(err);
                });
        });
    }

    static getPolicyByEnterpriseScope(wbSalesOrgId: number, StartDate: string, EndDate: string): Promise<number[]> {
        return new Promise<number[]>((resolve, error) => {
            PolicyService.loadFromDB().then(() => {
                if (wbSalesOrgId in PolicyService.dctPolicyByWbID) {
                    const policies = PolicyService.dctPolicyByWbID[wbSalesOrgId];
                    const retVal = _.filter(policies, (policy) =>
                        DateUtils.RangeDatesOverlap(
                            DateUtils.convertFromSAPBW(policy.cif.EFFECTIVE_START_DT),
                            DateUtils.convertFromSAPBW(policy.cif.EFFECTIVE_END_DT),
                            DateUtils.convertFromSAPBW(StartDate),
                            DateUtils.convertFromSAPBW(EndDate)
                        )
                    );
                    resolve(_.map(retVal, "WB_POLICY_ID") || [0]);
                } else resolve([0]);
            });
        });
    }

    private static async loadFromDB(): Promise<void> {
        if (PolicyService.bIsLoaded) return;

        PolicyService.instantiateContext();

        const policies: WB_PolicyRow[] = await PolicyService._dbContext.findAll(esWB_Policy, {
            where: { DELETED_IND: { neq: "1" } }
        });
        const policyOutputs: WB_PolicyCubeTermRow[] = await PolicyService._dbContext.findAll(
            esWB_Policy_Cube_TermR,
            { where: { DELETED_IND: { neq: "1" } } },
            { with: [esWB_Policy_Cube, esWB_Policy_Term, esWB_Policy_Term_Type] }
        );

        const policyTermTypes: WB_PolicyTermTypeRow[] = await PolicyService._dbContext.findAll(esWB_Policy_Term_Type, {
            where: { DELETED_IND: { neq: "1" } }
        });

        PolicyService.dctPolicyByWbID = _.groupBy(policies, "WB_SALESORG_ID");
        PolicyService.dctPolicyOutputTermByWbID = _.keyBy(policyOutputs, (aRel) => {
            return aRel.cif.WB_POLICYCUBETR_ID;
        });

        _.forEach(policyOutputs, (aPolicyRel) => {
            if (aPolicyRel.WB_PolicyCubeRow && aPolicyRel.WB_PolicyCubeRow.cif.CUBE_TYPE != "Primary") return;

            const arrTermTypes = _.filter(policyTermTypes, (row) => row.cif.WB_POLICYTERMM_ID == aPolicyRel.WB_PolicyTermRow.cif.WB_POLICY_TERMM_ID)
            for (const termType of arrTermTypes) {
                const tt = termType.cif
                if (!(tt.INPUT_STORAGE_TYPE == "ConditionType" && tt.TIME_MODE == "DesignTime"))
                    continue;

                if (_.isEmpty(aPolicyRel.WB_PolicyTermRow.cif.RESERVED_TERM_ID))
                    continue;

                if (!(aPolicyRel.cif.PRD_CNDM_ID > 0))
                    continue;
            }

            if (!(aPolicyRel.WB_PolicyCubeRow.cif.WB_POLICY_ID in PolicyService.dctCndTypeWbIDByPolicyWbIDCndTypeID)) {
                PolicyService.dctCndTypeWbIDByPolicyWbIDCndTypeID[aPolicyRel.WB_PolicyCubeRow.cif.WB_POLICY_ID] = {};
            }

            if (
                !(
                    aPolicyRel.WB_PolicyTermRow.cif.RESERVED_TERM_ID in
                    PolicyService.dctCndTypeWbIDByPolicyWbIDCndTypeID[aPolicyRel.WB_PolicyCubeRow.cif.WB_POLICY_ID]
                )
            )
                PolicyService.dctCndTypeWbIDByPolicyWbIDCndTypeID[aPolicyRel.WB_PolicyCubeRow.cif.WB_POLICY_ID][
                    aPolicyRel.WB_PolicyTermRow.cif.RESERVED_TERM_ID
                    ] = {};

            const cubeRow = aPolicyRel.WB_PolicyCubeRow.cif;
            const key = cubeRow.WB_ENTITY_ID_PRODUCT + "-" + aPolicyRel.WB_PolicyCubeRow.cif.WB_ENTITY_ID_CUSTOMER;
            PolicyService.dctCndTypeWbIDByPolicyWbIDCndTypeID[aPolicyRel.WB_PolicyCubeRow.cif.WB_POLICY_ID][
                aPolicyRel.WB_PolicyTermRow.cif.RESERVED_TERM_ID
                ][key] = aPolicyRel?.cif?.PRD_CNDM_ID || 0;
        });

        PolicyService.bIsLoaded = true;
    }

    static async reset(): Promise<void> {
        PolicyService.instantiateContext();
        let arr: any[] = [];

        arr = _.values(PolicyService.dctPolicyByWbID);
        await PolicyService._dbContext.purgeCache(esWB_Policy, arr);
        PolicyService.dctCndTypeWbIDByPolicyWbIDCndTypeID = {};

        arr = _.values(PolicyService.dctPolicyOutputTermByWbID);
        await PolicyService._dbContext.purgeCache(esWB_Policy_Cube_TermR, arr);
        PolicyService.dctPolicyOutputTermByWbID = {};
    }

    private static instantiateContext() {
        if (_.isUndefined(PolicyService._dbContext)) {
            PolicyService._dbContext = new PAdbContext();
        }
    }
}
